/**
 * @generated SignedSource<<3e5293e036fb2f0e19ccfe6940ad4a68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment$data = {
  readonly id: string;
  readonly template: {
    readonly key: string;
    readonly title: string;
  };
  readonly " $fragmentType": "personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment";
};
export type personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment$key = {
  readonly " $data"?: personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment"
};

(node as any).hash = "90018b6c89b0c3b15fd3af184c923aab";

export default node;
